import { render, staticRenderFns } from "./PopupLightbox.vue?vue&type=template&id=2c82de06&"
import script from "./PopupLightbox.vue?vue&type=script&lang=js&"
export * from "./PopupLightbox.vue?vue&type=script&lang=js&"
import style0 from "./PopupLightbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports